import { NovelGallerySubReducer } from "@customer-gallery/redux/galleryTypedRedux";
import { ITokenCollectionClaimWithTokenCollection } from "@novel/shared/interfaces/TokenCollectionClaim";

export interface IUnclaimedTokensReducerState {
    isLoading: boolean;
    isClaimingToken: string | null;
    unclaimedTokens: ITokenCollectionClaimWithTokenCollection[];
}

const initialState: IUnclaimedTokensReducerState = {
    isLoading: true,
    isClaimingToken: null,
    unclaimedTokens: [],
};

export const unclaimedTokensReducer: NovelGallerySubReducer<IUnclaimedTokensReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOG_OUT": {
            return {
                ...state,
                isLoading: false,
                unclaimedTokens: [],
            };
        }

        case "LOADING_UNCLAIMED_TOKENS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_UNCLAIMED_TOKENS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_UNCLAIMED_TOKENS": {
            return {
                ...state,
                isLoading: false,
                unclaimedTokens: action.payload.tokenCollectionClaims,
            };
        }

        case "LOADED_CLAIMING_TOKEN_LINE_ITEM": {
            return {
                ...state,
                isLoading: false,
                isClaimingToken:
                    state.isClaimingToken === action.payload.tokenCollectionClaim.id
                        ? null
                        : state.isClaimingToken,
                unclaimedTokens: state.unclaimedTokens
                    .map((unclaimedTokenLineItem) => ({
                        ...unclaimedTokenLineItem,
                        unclaimedQuantity:
                            unclaimedTokenLineItem.id === action.payload.tokenCollectionClaim.id
                                ? action.payload.tokenCollectionClaim.unclaimedQuantity
                                : unclaimedTokenLineItem.unclaimedQuantity,
                    }))
                    .filter((unclaimedTokenLineItem) => !!unclaimedTokenLineItem.unclaimedQuantity),
            };
        }

        case "LOADING_CLAIMING_TOKEN_LINE_ITEM": {
            return {
                ...state,
                isClaimingToken: action.payload.claimId,
            };
        }

        case "ERROR_LOADING_CLAIMING_TOKEN_LINE_ITEM": {
            if (action.payload.claimId === state.isClaimingToken) {
                return {
                    ...state,
                    isClaimingToken: null,
                };
            }

            return state;
        }

        default: {
            return state;
        }
    }
};
